// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"DropdownMenu-StyledDropdownMenu-module--styled-dropdown-menu--1O1PQ","show":"DropdownMenu-StyledDropdownMenu-module--show--fxdsH"};